import React, { useState } from "react";
import AddNewBook from "./AddNewBook";
import BookContainer from "./BookContainer";
import BookFilter from "./BookFilter";

export default function Main() {
  const [editMode, setEditMode] = useState(false);
  const [onEdit, setOnEdit] = useState();

  const handleEdit = (id, name, author, thumbnail, price, rating, featured) => {
    setEditMode(true);
    setOnEdit({ id, name, author, thumbnail, price, rating, featured });
  };
  const handleCancel = () => {
    setEditMode(false);
  };

  return (
    <main className="py-12 2xl:px-6">
      <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
        <div className="order-2 xl:-order-1">
          <BookFilter />
          <BookContainer handleEdit={handleEdit} />
        </div>
        <AddNewBook
          onEdit={onEdit}
          handleCancel={handleCancel}
          editMode={editMode}
        />
      </div>
    </main>
  );
}
